import { trpcVanilla } from "@client/trpc";
import {
  createSyncFeature,
  type StorageLike,
  type SyncFeature,
} from "@client/sync";

export interface PlaylistPayload {
  orderedVideoIds: string[];
  clientUpdatedAt: string;
}

export interface PlaylistFlushResult {
  applied: boolean;
}

export function createPlaylistSync(
  args: {
    storage?: StorageLike;
    storageKey?: string;
    shouldCommit?: () => boolean;
  } = {},
): SyncFeature<PlaylistPayload> {
  return createSyncFeature<PlaylistPayload, PlaylistFlushResult>({
    storageKey: args.storageKey ?? "mobileVideoSync.playlist.v1",
    // Playlist writes are full-state replacements; the latest one always
    // supersedes any pending earlier one.
    coalesce: (_existing, incoming) => incoming,
    send: (payload) =>
      trpcVanilla.setVideoPlaylistOrder.mutate({
        orderedVideoIds: payload.orderedVideoIds,
        clientUpdatedAt: payload.clientUpdatedAt,
      }),
    storage: args.storage,
    shouldCommit: args.shouldCommit,
  });
}
